import { render } from "./btc_deposit.vue?vue&type=template&id=8b1f829e&scoped=true"
import script from "./btc_deposit.vue?vue&type=script&lang=js"
export * from "./btc_deposit.vue?vue&type=script&lang=js"

import "./btc_deposit.vue?vue&type=style&index=0&id=8b1f829e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1f829e"]])

export default __exports__